import '@styles/site.scss';
import { onDomReady } from '@scripts/helpers/utils';
import * as plugins from '@scripts/plugins';
import { loadModules } from '@scripts/helpers/modules-loader';
import { handleHash, handleQueryParam } from '@scripts/helpers/deeplink';

onDomReady().then(() => {
	Object.values(plugins).forEach((factory) => factory());
	loadModules().then(() => {
		handleHash();
		handleQueryParam();
	});
});
